<template>
  <div>
    <PopoverView v-if="!narrow" :active="active" :placement="placement" :size="size" @update:active="emit('update:active', $event)">
      <template v-slot:target>
        <slot name="target"></slot>
      </template>
      <template v-slot:body>
        <slot name="body"></slot>
      </template>
    </PopoverView>
    <div v-else>
      <slot name="target"></slot>
      <ModalView :active="active" :size="size" @update:active="emit('update:active', $event)">
        <template v-if="$slots.header" v-slot:header>
          <slot name="header"></slot>
        </template>
        <template v-if="$slots.body" v-slot:body>
          <slot name="body"></slot>
        </template>
      </ModalView>
    </div>
  </div>
</template>

<script setup>
import PopoverView from "./PopoverView.vue";
import ModalView from "../../plugins/modal/ModalView.vue";
import {onBeforeUnmount, onMounted, ref} from "vue";

defineProps({
  active: Boolean,
  placement: String,
  size: String
});

const emit = defineEmits(["update:active"]);

const narrow = ref(window.innerWidth < 992);

function resized() {
  narrow.value = window.innerWidth < 992;
}

onMounted(() => {
  window.addEventListener("resize", resized);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", resized);
});

</script>